<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
            <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Configuración</div>
              Tipo Representación<select class="form-control" v-model="bUsesImage">
                <option value="0">Esferas</option>
                <option value="1">Imagen</option>
              </select>
              <div v-if="bUsesImage !== '0'">
              <br/>
                  <label>Imagen</label>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                  <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                    <input type="text" v-model="configuration.IMAGENES_ID"
                      disabled class="form-control" style="display:none"/>
                    <div class="image">
                        <img :src="getTranslation(configuration.text.IMAGEN)" alt="img"
                        style="width:auto;max-height:110px" class="img-fluid">
                    </div>
                    <searchimages class="pl-2" idModal="mdlSearchImage"
                      v-on:selected="onSelectedImage($event)">
                    </searchimages>
                  </div>
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div>
                <br/>
                Posición Representación<select class="form-control" v-model="configuration.TIPO_REPRESENTACION">
                  <option value="0">Columnas Base 10</option>
                  <option value="1">Tamaño optimizado ordenado</option>
                  <option value="2">Tamaño optimizado aleatorio</option>
                </select>
              </div>
              <br>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.INDICATIVO_UNIDAD"
                id="indicativounidad">
                <label class="custom-control-label" for="indicativounidad">Indicativo Unidad</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.INCLUIR_ALGORITMO"
                id="INCLUIR_ALGORITMO">
                <label class="custom-control-label" for="INCLUIR_ALGORITMO">Incluir Algoritmo</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Representaciones</div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.VERBAL_ORAL"
                id="verbaloral">
                <label class="custom-control-label" for="verbaloral">Verbal oral</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                  id="VERBAL_ESCRITO" v-model="configuration.VERBAL_ESCRITO">
                <label class="custom-control-label" for="VERBAL_ESCRITO">Verbal Escrito</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.REPRESENTACION_GRAFICA"
                id="REPRESENTACION_GRAFICA">
                <label class="custom-control-label" for="REPRESENTACION_GRAFICA">Representación Grafica</label>
              </div>
            </div>
            <div class="col-md-4">
            <div class="mb-2 font-weight-bold">Respuestas</div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.RESP_VERBAL_ORAL"
                id="respverbaloral">
                <label class="custom-control-label" for="respverbaloral">
                  Respuesta Verbal Oral</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.RESP_VERBAL_ESCRITO"
                id="RESP_VERBAL_ESCRITO">
                <label class="custom-control-label" for="RESP_VERBAL_ESCRITO">Respuesta Verbal Escrito</label>
              </div>
            </div>
      </div>
      <br>
      <hr/>
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row  class="justify-content-md-center">
          <b-col col lg="2" style="text-align:center"><h6>Operando 1</h6></b-col>
          <b-col col lg="2" style="text-align:center"><h6>Operador</h6></b-col>
          <b-col col lg="2" style="text-align:center"><h6>Operando 2</h6></b-col>
          <b-col col lg="2" style="text-align:center"><h6>Resultado</h6></b-col>
          <b-col col lg="2" style="text-align:center"><h6>Incógnita</h6></b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col col lg="2">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input
                      v-bind:id="'OPERADOR1' + index"
                      type="number"
                      v-model="arrayEleOperation[index].OPERADOR1" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col col lg="2">
                <select class="form-control" v-model="arrayEleOperation[index].OPERANDO">
                  <option value="+">+</option>
                  <option value="-">-</option>
                  <option value="*">*</option>
                  <option value="/">/</option>
                </select>
              </b-col>
              <b-col col lg="2">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input
                      v-bind:id="'OPERADOR2' + index"
                      type="number"
                      v-model="arrayEleOperation[index].OPERADOR2" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col col lg="2">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-input
                      v-bind:id="'RESULTADO' + index"
                      type="number"
                      v-model="arrayEleOperation[index].RESULTADO" />
                  <span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col col lg="2">
                <select class="form-control" v-model="arrayEleOperation[index].INCOGNITA">
                  <option value="1">Primer operando</option>
                  <option value="2">Signo operación</option>
                  <option value="3">Segundo operando</option>
                  <option value="4">Respuesta</option>
                </select>
              </b-col>
          </b-row>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="preSaveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';
import searchimages from '../../images/SearchImages.vue';
import translationMixin from '../../../../mixins/translation';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin, translationMixin],
  components: {
    exercises,
    searchimages,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      arrayEleOperation: [],
      bUsesImage: '0',
      // Mapear con los campos de la tabla SUMARESTAALG_CONF
      configuration: {
        ID: null,
        VERBAL_ORAL: false,
        VERBAL_ESCRITO: true,
        REPRESENTACION_GRAFICA: true,
        IMAGENES_ID: null,
        TIPO_REPRESENTACION: 0,
        INCLUIR_ALGORITMO: false,
        RESP_VERBAL_ORAL: true,
        RESP_VERBAL_ESCRITO: true,
        EJERCICIOS_ID: -1,
        text: { // Used for display
          IMAGEN: [],
        },
      },
    };
  },
  methods: {
    /**
    * @method onSelectedImage
    * @description Al seleccionar una imagen
    */
    onSelectedImage(itemSelected) {
      this.configuration.IMAGENES_ID = itemSelected.ID;
      this.configuration.text.IMAGEN = itemSelected.FICHERO;
      this.$root.$emit('bv::hide::modal', 'mdlSearchImage');
    },
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        OPERADOR1: null,
        OPERANDO: '+',
        OPERADOR2: null,
        RESULTADO: null,
        INCOGNITA: 1,
      });
    },
    /**
    * @method saveStorage
    * @description Guarda los datos del formulario
    */
    preSaveStorage() {
      // Override image saving if not using images
      if (this.bUsesImage === '0' || this.bUsesImage === false) {
        this.configuration.IMAGENES_ID = 0;
      }

      this.saveStorage();
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('arithmeticfacts/getarithmeticfacts', {
          params: {
            ejercicios_id: id,
          },
        });

        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            OPERADOR1: element.OPERADOR1,
            OPERANDO: element.OPERANDO,
            OPERADOR2: element.OPERADOR2,
            RESULTADO: element.RESULTADO,
            INCOGNITA: element.INCOGNITA,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
    try {
      this.bUsesImage = (this.configuration.IMAGENES_ID !== null && this.configuration.IMAGENES_ID !== 0) ? '1' : '0';
    } catch {
      this.bUsesImage = '0';
    }
  },
};
</script>
